(() => {
    jQuery(document).ready(function ($) {


        const url = new URL(window.location.href);
        const pf = $("#practice-filter");

        if (pf) {
            pf.on('change', function() {
                window.location.href = url.origin + url.pathname + '?practice=' + pf.val();
            });
        }

        // let practiceParameter = url.search.replace('?practice=', '');

        if (url.search.includes('?practice=')) {
            let practiceParameter = url.search.replace('?practice=', '');
            console.log(practiceParameter);
        }

    });

})();